// eslint-disable-next-line import/prefer-default-export
export const submissionStages = {
  Validating: 'validating',
  Confirmation: 'confirmation',
  Certification: 'certification',
  Signing: 'signing',
  Submission: 'submission'
};
